import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import notificationsReducer from './store/notificationsSlice';
import coreReducer from './store/coreSlice';
import {configureStore, combineReducers} from "@reduxjs/toolkit";
import {Provider} from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import Modals from "./components/Modals/Modals";
import modalsReducer from "./store/modalsSlice";
import {isDevel} from "./utils";

const store = configureStore({ reducer: combineReducers({
	notifications: notificationsReducer,
	core: coreReducer,
	modals: modalsReducer
})});

ReactDOM.render((
	<BrowserRouter basename={isDevel() ? '/' : '/alerts/'}>
	<Provider store={store}>
		<Modals />
		<App />
	</Provider>
	</BrowserRouter>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
